import { createPatchEndpoint } from '@sonar-software/sonar-http';

import { AutodocTypeFlag, BusinessContext } from '@types';

export type PatchSonarObjectBusinessContextRequest = {
	sonarObjectId: number;
	context: Partial<BusinessContext>;
};

export type PatchSonarObjectBusinessContextResponse = {
	aiGeneratedTracking: AutodocTypeFlag;
};

export const patchSonarObjectBusinessContext = createPatchEndpoint<
	PatchSonarObjectBusinessContextRequest,
	PatchSonarObjectBusinessContextResponse
>(
	({ sonarObjectId }) => `/api/v3/core/sonar-objects/${sonarObjectId}/context`,
	{
		requestTransform: ({ context }) => context
	}
);
